import LocomotiveScroll from 'locomotive-scroll';

const body  = document.body;
const home  = body.classList.contains('home');

if (home) {

    // =======================================================
    // Init smooth scroll
    // =======================================================
    if(window.innerWidth > 1040) {
        const scroll = new LocomotiveScroll({
            el: document.querySelector('[data-scroll-container]'),
            smooth: true,
            multiplier: 1.1
        });
    }  
    // =======================================================


    // =======================================================
    // Open / Close Access
    // =======================================================
    let access        = document.querySelector('.access');
    let accessOpen    = document.querySelector('.access__open');
    let accessClose   = document.querySelector('.access__close');
    let home          = document.querySelector('.front-page');
    let homeslide     = document.querySelector('.home-slideshow');
    let accessLinks   = document.querySelectorAll('.access__link');

    if(window.innerWidth > 1040) {
        // home.appendChild(access);
        home.insertBefore(access, homeslide);
        // console.log("ou est lenfant");
    }

    accessLinks.forEach(function (accessLink) {           
        accessLink.setAttribute('tabindex', -1);
        // console.log("tabindex-1");
    });
    accessClose.setAttribute('tabindex', -1);

    accessOpen.addEventListener('click', function () {
        access.classList.add('access-js-active');
        home.classList.add('js-active');

        accessLinks.forEach(function (accessLink) {           
            accessLink.setAttribute('tabindex', 0);
            // console.log("tabindex-0");
        });
        accessClose.setAttribute('tabindex', 0);
    });

    accessClose.addEventListener('click', function () {
        access.classList.remove('access-js-active');
        home.classList.remove('js-active');

        accessLinks.forEach(function (accessLink) {           
            accessLink.setAttribute('tabindex', -1);
            // console.log("tabindex-1");
        });
        accessClose.setAttribute('tabindex', -1);
    });

    document.addEventListener("mouseup", function(event) {
        if (!access.contains(event.target)) {
            access.classList.remove('access-js-active');
            home.classList.remove('js-active');

            accessLinks.forEach(function (accessLink) {           
                accessLink.setAttribute('tabindex', -1);
                // console.log("tabindex-1");
            });
            accessClose.setAttribute('tabindex', -1);
        }
    });
    // =======================================================

    // const backToTop = document.querySelector("#js-back-to-top");
    // console.log(backToTop);
    // const opacityClass = "opacity-0";
    // const visibilityClass = "invisible";

    // scroll.on("call", (value, way, obj) => {
    //     if (value === "toggleBackToTop") {
            
    //       if (way === "enter") {
    //         backToTop.classList.add("invisible");
    //         console.log("hzlo");
    //       } else {
    //         backToTop.classList.remove("invisible");
    //         console.log("hzlo2");
    //       }
    //     }
    //   });

}
